import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError(error => {
      console.error('API Error:', error);

      if (error.status === 401) {
        localStorage.removeItem('token');
        router.navigate(['/auth/login']);
      }

      return throwError(() => error);
    })
  );
};
